import { render, staticRenderFns } from "./FormRegisterIdentificator.vue?vue&type=template&id=7caf9f42&scoped=true&"
import script from "./FormRegisterIdentificator.vue?vue&type=script&lang=js&"
export * from "./FormRegisterIdentificator.vue?vue&type=script&lang=js&"
import style0 from "./FormRegisterIdentificator.vue?vue&type=style&index=0&id=7caf9f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caf9f42",
  null
  
)

export default component.exports